const businessOfficerTitle = () => {
  return [
    { value: "OFFICER", label: "Officer" },
    { value: "FOUNDER", label: "Founder" },
    { value: "DIRECTOR", label: "Director" },
  ];
};

export default businessOfficerTitle;
